const RequestDataDto = {
	id: null,
	requestDataCode: null,
	requestDataName: null,
	directoryPath: "",
	description: "",
	statusName: "",
	oldStatus: null,
	objectSchema: "",
	objectModel: "",
	erpBodyMap: "",
	expiredTime: new Date(),
	createdName: "",
	createdDate: new Date(),
	modifiedName: "",
	modifiedDate: new Date(),
	isActive: true,
	isDelete: false,
	tenantCode: "",
	request: null,
	status: null,
	created: null,
	modified: null,
	userInfos: null,
	requestDataList: [],
	currentRound: null,
	requestGroupName: "",
	requestTypeName: "",
	plotOfLandNumber: null,
	title: "",
	sapMapping: "",
	ruleGenerateAttachName: "",
	formMapping: "",
	requestDataCodeFromPreviousPYC: "",
	requestDataIdFromPreviousPYC: "",
	parentRequestDataId: "",
};
export default RequestDataDto;
